import { MessageCircle, Phone } from 'lucide-react';
import { useCompany } from '@site/content';

/** Floating call + WhatsApp buttons (bottom-right). */
export default function QuickContact() {
  const company = useCompany();
  return (
    <div className="pb-safe fixed bottom-4 right-4 z-30 flex flex-col gap-3">
      <a
        href={company.whatsappHref}
        target="_blank"
        rel="noreferrer"
        aria-label="Chat with us on WhatsApp"
        className="flex h-12 w-12 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-black/20 transition-transform hover:scale-105"
      >
        <MessageCircle className="h-6 w-6" aria-hidden="true" />
      </a>
      <a
        href={company.phoneHref}
        aria-label={`Call ${company.phone}`}
        className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-600 text-white shadow-lg shadow-primary-900/30 transition-transform hover:scale-105 md:hidden"
      >
        <Phone className="h-5 w-5" aria-hidden="true" />
      </a>
    </div>
  );
}
